<template>
  <div class="mask" @click="close()">
    <div class="image-review-box" @click.stop="stop()">
      <div class="image-info">
        <div class="left">
          <img v-if="!materialItem.docType" :src="materialItem.ossPath" alt />
          <video
            v-else
            ref="video"
            autoplay
            :src="materialItem.ossPath"
            controls
          ></video>
        </div>
        <div class="right">
          <div class="main">
            <div class="module-box">
              <h3 class="title">数据</h3>
            </div>
            <div class="data-box">
              <p>
                分享
                <br />
                <span>{{ materialItem.shareCount || 0 }}</span>
              </p>
              <p>
                点赞
                <br />
                <span>{{ materialItem.likeCount || 0 }}</span>
              </p>
              <p>
                下载
                <br />
                <span>{{ materialItem.downloadCount || 0 }}</span>
              </p>
              <p>
                展示次数
                <br />
                <span>{{ materialItem.viewCount || 0 }}</span>
              </p>
              <p>
                评论次数
                <br />
                <span>{{ materialItem.commentCount || 0 }}</span>
              </p>
            </div>
            <ul class="information">
              <li class="origin">
                <div class="label">
                  来源：
                </div>
                <div class="value">
                  <img src="../assets/images/wezonet-icon.png" alt />
                  <span>Wezonet</span>
                </div>
              </li>
              <li>
                <div class="label">
                  名称：
                </div>
                <div class="value">
                  {{ materialItem.fileName || "--" }}
                </div>
              </li>
              <li>
                <div class="label">
                  投放地区：
                </div>
                <div class="value">
                  --
                </div>
              </li>
              <li>
                <div class="label">
                  发布时间：
                </div>
                <div class="value">
                  {{ materialItem.createDate }}
                </div>
              </li>
              <li>
                <div class="label">
                  作者：
                </div>
                <div class="value">
                  --
                </div>
              </li>
              <li>
                <el-button type="text" @click="downloadVideo"
                  >下载{{ materialItem.docType ? "视频" : "图片" }}</el-button
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <i class="close" @click.stop="close"></i>
  </div>
</template>
<script>
import {
  getSimilarFileList,
  downloadThirdPartyFile,
  // getVideoDetail,
  downloadFileByStream
} from "../assets/js/api";
import { PromiseWidget } from "../assets/js/tools";
import { LOADING_OPTIONS } from "../assets/tools/common";
export default {
  props: {
    materialItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {},
  data() {
    return {
      currentPage: 1,
      imageList: [],
      currentIndex: -1,
      waterfallWidth: 4,
      dataList: []
      // videoPath: ""
    };
  },
  methods: {
    async downloadVideo() {
      const loading = this.$loading({
        lock: true,
        text: "唤起下载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = await downloadFileByStream(this.materialItem.fileId);
      this.$nextTick(() => {
        loading.close();
      });
      if (data) {
        const objectURL = URL.createObjectURL(data);
        const aTag = document.createElement("a");
        aTag.href = objectURL;
        aTag.download = `${this.materialItem.fileId}.mp4`;
        document.body.appendChild(aTag);
        aTag.click();
        aTag.remove();
      }
    },
    reviewImage(item) {
      this.$emit("changeReview", item);
    },
    changeImage(index) {
      this.$emit("toggleReview", index);
    },
    loadMore() {
      this.currentPage++;
    },
    init() {
      this.currentPage = 1;
      this.dataList = [];
    },

    stop() {},
    close() {
      this.$refs.video && this.$refs.video.pause();
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(229, 229, 229, 0.95);
  padding-top: 60px;
  overflow-y: auto;

  &.dark {
    background-color: rgba(0, 0, 0, 0.8);

    .image-review-box {
      .image-info {
        .left,
        .right {
          background-color: #1f2022;

          .module-box {
            .tag-list {
              .tag-item {
                background-color: #565656;
                border-color: #565656;
                color: #c0c4cc;
                &:hover {
                  border-color: #565656;
                }

                &.hot-tag {
                  color: #fff;
                  border-color: #1983f9;
                  background: linear-gradient(
                    135deg,
                    rgba(25, 131, 249, 1) 0%,
                    rgba(112, 48, 255, 1) 100%
                  );
                  position: relative;

                  &:after {
                    position: absolute;
                    right: -8px;
                    top: -7px;
                    content: " ";
                    width: 20px;
                    height: 14px;
                    background: url(../assets/images/hot-tag-icon.png) no-repeat
                      center center;
                  }
                }
              }
            }
            h3.title {
              color: #fff;
              &:after {
                background: linear-gradient(
                  90deg,
                  rgba(25, 131, 249, 1) 0%,
                  rgba(112, 48, 255, 1) 100%
                );
              }
            }

            p {
              color: #c0c4cc;
            }
          }
        }
      }
      .image-similar-list {
        .title {
          border-bottom-color: #343538;
        }
        .image-list {
          .image-item {
            background-color: #27282a;
            &:hover {
              background-color: #17181a;
            }

            .info {
              border-bottom-color: #343538;
              h3.title {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  i.close {
    width: 50px;
    height: 50px;
    background: url(../assets/images/close-icon.png) no-repeat center center;
    position: fixed;
    right: 30px;
    top: 30px;
    cursor: pointer;
  }

  i.icon {
    width: 60px;
    height: 150px;
    top: 50%;
    margin-top: -75px;
    background: url(../assets/images/next-icon.png) no-repeat center center;
    position: fixed;
    cursor: pointer;
    &:hover {
      background: url(../assets/images/next-active-icon.png) no-repeat center
        center rgba(144, 147, 153, 0.3);
    }

    &.prev {
      left: 0;
      transform: rotate(180deg);
      &:hover {
        background: url(../assets/images/next-active-icon.png) no-repeat center
          center rgba(144, 147, 153, 0.3);
        transform: rotate(0deg);
      }
    }

    &.next {
      right: 0;
      transform: rotate(0deg);
      &:hover {
        background: url(../assets/images/next-active-icon.png) no-repeat center
          center rgba(144, 147, 153, 0.3);
        transform: rotate(180deg);
      }
    }
  }

  .image-review-box {
    width: 1152px;
    margin: 0 auto;
    .image-info {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .left {
        width: 832px;
        padding: 20px;
        background-color: #fff;
        box-sizing: border-box;
        margin-right: 20px;
        min-height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        img,
        video {
          display: block;
          margin: 0;
          max-width: 100%;
          outline: none;
        }

        video {
          max-height: 560px;
        }
      }

      .right {
        width: 300px;
        min-height: 600px;
        box-sizing: border-box;

        .main,
        .author {
          background-color: #fff;
          padding: 25px 20px;
          border-radius: 5px;
        }

        .main {
          min-height: 450px;
        }

        .author {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 20px;

          p {
            color: #c0c4cc;
            margin: 0;
          }

          .origin {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            p {
              margin-left: 10px;
              color: #606266;
              font-size: 16px;
            }
          }
        }

        .data-box {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          margin-top: 20px;
          p {
            width: 33.33%;
            color: #606266;
            margin: 0 0 20px;

            &:nth-child(4),
            &:nth-child(5) {
              margin-bottom: 0;
            }
            span {
              color: #c0c4cc;
              margin-top: 3px;
              display: block;
            }
          }
        }

        .information {
          margin: 20px 0 0;
          border-top: 1px solid #dcdfe6;
          padding-top: 20px;
          li {
            display: flex;
            overflow: hidden;
            font-size: 14px;
            margin-bottom: 10px;
            .label {
              flex: 0 0 70px;
            }
            .value {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #c0c4cc;
            }
          }
          .origin {
            img {
              height: 20px;
              margin-right: 10px;
            }
            img,
            span {
              vertical-align: middle;
            }
          }
        }

        .module-box {
          &:first-child {
            h3.title {
              margin-top: 0;
            }
          }
          h3.title {
            color: #000;
            font-size: 16px;
            font-weight: 600;
            padding-left: 14px;
            box-sizing: border-box;
            width: 100%;
            position: relative;
            margin: 30px 0 20px;
            text-align: left;
            height: 20px;
            line-height: 20px;
            &:after {
              content: " ";
              position: absolute;
              left: 0;
              top: 0;
              width: 4px;
              height: 16px;
              border-radius: 2px;
              background: linear-gradient(
                180deg,
                rgba(250, 213, 44, 1) 0%,
                rgba(255, 96, 41, 1) 100%
              );
            }
          }

          .tag-list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            .tag-item {
              padding: 0 10px;
              border: 1px solid #bfbfbf;
              background-color: #f8f8f8;
              border-radius: 5px;
              color: #606266;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
              margin: 0 20px 10px 0;
              cursor: pointer;

              &.hot-tag {
                color: #fff;
                border-color: #ff6029;
                background: linear-gradient(
                  135deg,
                  rgba(250, 213, 44, 1) 0%,
                  rgba(255, 96, 41, 1) 100%
                );
                position: relative;

                &:after {
                  position: absolute;
                  right: -8px;
                  top: -7px;
                  content: " ";
                  width: 20px;
                  height: 14px;
                  background: url(../assets/images/hot-tag-icon.png) no-repeat
                    center center;
                }
              }
              &.active {
                border: 1px solid #1983f9;
              }
            }
          }

          p {
            text-align: left;
            margin: 0;
            font-size: 16px;
            word-break: break-all;
          }
        }
      }
    }

    .image-similar-list {
      margin-top: 30px;
      padding-bottom: 50px;
      h3.title {
        color: #606266;
        font-size: 20px;
        font-weight: 400;
        margin: 0;
        padding-bottom: 10px;
        border-bottom: 1px solid #909399;
        text-align: left;
      }

      .image-list {
        padding: 30px 0;
        .image-item {
          background-color: #fff;
          box-shadow: 0px 3px 10px rgba(16, 72, 132, 0.15);
          margin-bottom: 20px;

          &:hover {
            background-color: #fff;
            box-shadow: 0px 6px 12px rgba(11, 75, 143, 0.2);
            transform: translateY(-1px);
            transition: all 0.5s;
          }
        }
        .image-box {
          position: relative;
          img {
            max-width: 100%;
            display: block;
            &.video-play {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate3d(-50%, -50%, 0);
              width: 50px;
              height: 50px;
            }
          }
          cursor: pointer;
        }

        .info {
          padding: 20px 0;
          border-bottom: 1px solid #dcdfe6;
          h3.title {
            padding: 0 16px;
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            margin: 0;
            text-align: left;
            border-bottom: 0;
            color: #303133;
            word-break: break-all;
            p {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              margin: 0 0 0 8px;
              i {
                width: 20px;
                height: 20px;
                background: url(../assets/images/file-size.png) no-repeat;
              }
            }
          }

          p.desc {
            color: #909399;
            margin-top: 10px;
            text-align: left;
            padding: 0 16px;
          }

          .label-list {
            display: flex;
            padding: 0 16px;
            justify-content: flex-start;
            align-items: center;
            margin-top: 20px;
            .label-item {
              padding: 0 8px;
              height: 22px;
              line-height: 22px;
              background-color: #565656;
              color: #c0c4cc;
              font-size: 12px;
              border-radius: 5px;
              margin-right: 10px;

              &.hot-tag {
                color: #fff;
                border-color: #ff6029;
                background: linear-gradient(
                  135deg,
                  rgba(250, 213, 44, 1) 0%,
                  rgba(255, 96, 41, 1) 100%
                );
                position: relative;

                &.active {
                  background: #fff;
                  color: #ff6029;
                  border-color: #ff6029;
                }

                &:after {
                  position: absolute;
                  right: -8px;
                  top: -7px;
                  content: " ";
                  width: 20px;
                  height: 14px;
                  background: url(../assets/images/hot-tag-icon.png) no-repeat
                    center center;
                }
              }
            }
          }
        }

        .share {
          padding: 10px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            width: 20px;
            height: 20px;
            background: url(../assets/images/google-icon.png) no-repeat;
            &.facebook {
              background: url(../assets/images/facebook-icon.png) no-repeat;
            }
          }

          p {
            margin: 0;
            color: #606266;
          }
        }
      }
    }
  }
}
</style>
